<app-image-section-head [title]="title" [description]="description" [image]="image"></app-image-section-head>

<main id="main-content" class="container mb-3">
    <div class="row">
        <div class="col-12">
            <div *ngIf="wpData" [outerHTML]="wpData.content.rendered"></div>

            <h2 class="my-4" i18n>Tipos de autorizaciones</h2>

            <div class="row">
                <ng-container *ngFor="let card of cards; let i = index;">
                    <div class="col-md-12 col-lg-6 col-xl-4 mb-3">
                        <app-information-card [styleClass]="'primary-white'" [title]="card.name" [description]="card.description || ''" [iconSVG]="card.icon" [buttonText]="buttonText" [hidden]="i >= itemsToShow" [hideButtons]="false" (buttonClick)="goTo(card.code)"></app-information-card>
                    </div>
                </ng-container>
                <div class="col-12 mb-3 text-center">
                    <button class="btn btn-primary" (click)="showMore()" *ngIf="itemsToShow < cards.length" i18n>Ver más</button>
                </div>
            </div>
        </div>
    </div>
</main>